import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Star, Quote, Users, ThumbsUp, ShieldCheck } from 'lucide-react';
export function TestimonialSection() {
  const testimonials = [{
    quote: "I lost 18 lbs in the first month and my knees haven't felt this good since my 30s. I can actually play basketball with my son again.",
    author: 'Mark R.',
    age: '54',
    title: 'Former College Athlete',
    rating: 5
  }, {
    quote: "My orthopedist asked what I changed. My inflammation markers dropped 40% in 6 weeks. This isn't just a workout plan — it's joint rehab that burns fat.",
    author: 'Dave T.',
    age: '58',
    title: 'Sales Executive',
    rating: 5
  }, {
    quote: 'I was two months away from scheduling knee replacement surgery. After 4 weeks on this program, I cancelled the consultation. Down 12 lbs and climbing stairs pain-free.',
    author: 'Jim K.',
    age: '61',
    title: 'Retired Engineer',
    rating: 5
  }];
  return <Section background="darker" className="border-t border-slate-900 pb-8 md:pb-12" data-id="element-265">
      <div className="text-center mb-16" data-id="element-266">
        <span className="text-brand-orange font-bold uppercase tracking-widest text-sm mb-2 block" data-id="element-267">
          Real Results
        </span>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white uppercase" data-id="element-268">
          Men Like You Are{' '}
          <span className="text-brand-orange" data-id="element-269">Getting Results</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-270">
        {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1,
        duration: 0.5
      }} viewport={{
        once: true
      }} className="bg-slate-900 border border-slate-800 p-8 rounded-xl relative hover:border-brand-orange/30 transition-colors" data-id="element-271">
            <Quote className="absolute top-6 right-6 text-brand-orange/20 w-10 h-10" data-id="element-272" />

            <div className="flex gap-1 mb-6" data-id="element-273">
              {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 text-brand-orange fill-brand-orange" data-id="element-274" />)}
            </div>

            <p className="text-slate-300 text-lg mb-6 leading-relaxed italic" data-id="element-275">
              "{testimonial.quote}"
            </p>

            <div className="flex items-center gap-4 border-t border-slate-800 pt-6" data-id="element-276">
              <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-brand-orange font-bold font-heading" data-id="element-277">
                {testimonial.author.charAt(0)}
              </div>
              <div data-id="element-278">
                <p className="text-white font-bold" data-id="element-279">
                  {testimonial.author}, {testimonial.age}
                </p>
                <p className="text-slate-500 text-sm" data-id="element-280">{testimonial.title}</p>
              </div>
            </div>
          </motion.div>)}
      </div>

      {/* Stats Bar */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-slate-900 border border-slate-800 rounded-lg p-6 md:p-8 max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 md:gap-12" data-id="element-281">
        <div className="flex items-center gap-3" data-id="element-282">
          <Users className="text-brand-orange w-6 h-6" data-id="element-283" />
          <div data-id="element-284">
            <p className="text-2xl font-heading font-bold text-white" data-id="element-285">2,847+</p>
            <p className="text-slate-500 text-sm uppercase tracking-wide" data-id="element-286">
              Men Enrolled
            </p>
          </div>
        </div>

        <div className="hidden md:block w-px h-12 bg-slate-800" data-id="element-287"></div>

        <div className="flex items-center gap-3" data-id="element-288">
          <ThumbsUp className="text-brand-orange w-6 h-6" data-id="element-289" />
          <div data-id="element-290">
            <p className="text-2xl font-heading font-bold text-white" data-id="element-291">4.9/5</p>
            <p className="text-slate-500 text-sm uppercase tracking-wide" data-id="element-292">
              Average Rating
            </p>
          </div>
        </div>

        <div className="hidden md:block w-px h-12 bg-slate-800" data-id="element-293"></div>

        <div className="flex items-center gap-3" data-id="element-294">
          <ShieldCheck className="text-brand-orange w-6 h-6" data-id="element-295" />
          <div data-id="element-296">
            <p className="text-2xl font-heading font-bold text-white" data-id="element-297">30-Day</p>
            <p className="text-slate-500 text-sm uppercase tracking-wide" data-id="element-298">
              Guarantee
            </p>
          </div>
        </div>
      </motion.div>
    </Section>;
}